import { kanaToRomaji } from "./kanaToRomaji";
import {
    MASHOUKA_LABEL,
    MASHOUKA_SUFFIX,
    POLITE_NEGATIVE_PAST_LABEL,
    TO_OMOIMASU_LABEL,
    TO_OMOIMASU_READING_SUFFIX,
} from "./verbConjugation";
import { splitTeIruReading } from "./teIruConjugation";

type RomanizableForm = { label: string; reading: string };

// でした (the past copula) is its own word after ません, so it is kept apart
// the same way とおもいます is: without this, kanaToRomaji would run the two
// together into one unnatural word ("...masendeshita" instead of "...masen
// deshita").
const POLITE_NEGATIVE_PAST_COPULA_SUFFIX = "でした";

export function conjugationRomaji(form: RomanizableForm): string {
    if (form.label === MASHOUKA_LABEL && form.reading.endsWith(MASHOUKA_SUFFIX)) {
        return `${kanaToRomaji(form.reading.slice(0, -MASHOUKA_SUFFIX.length))}mashou ka`;
    }
    // と is a separate word after the plain form, so it is written apart:
    // "taberu to omoimasu" rather than "taberutoomoimasu".
    if (form.label === TO_OMOIMASU_LABEL && form.reading.endsWith(TO_OMOIMASU_READING_SUFFIX)) {
        return `${kanaToRomaji(form.reading.slice(0, -TO_OMOIMASU_READING_SUFFIX.length))} to omoimasu`;
    }
    if (form.label === POLITE_NEGATIVE_PAST_LABEL && form.reading.endsWith(POLITE_NEGATIVE_PAST_COPULA_SUFFIX)) {
        return `${kanaToRomaji(form.reading.slice(0, -POLITE_NEGATIVE_PAST_COPULA_SUFFIX.length))} deshita`;
    }
    // いる is a separate word after the te-form: "tabete iru", not "tabeteiru".
    const teIru = splitTeIruReading(form.label, form.reading);
    if (teIru) {
        return `${kanaToRomaji(teIru.teForm)} ${teIruAuxiliaryRomaji(teIru.auxiliary)}`;
    }
    return kanaToRomaji(form.reading);
}

// いる conjugated (いる, いない, いました, ...), with でした kept apart from
// ません exactly as in the polite negative past above: "imasen deshita".
function teIruAuxiliaryRomaji(auxiliary: string): string {
    if (auxiliary.endsWith(POLITE_NEGATIVE_PAST_COPULA_SUFFIX)) {
        return `${kanaToRomaji(auxiliary.slice(0, -POLITE_NEGATIVE_PAST_COPULA_SUFFIX.length))} deshita`;
    }
    return kanaToRomaji(auxiliary);
}
